<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header :title="$t('My Wallet')" class="common-header" ref="header" :style="headerStyle">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>

    <div class="div account_header">

      <div class="div predeposit">
        <span class="predeposit_title">{{ $t('Available Balance') }}</span>
        <span class='available_predeposit'>{{ available_predeposit }}</span>
        <span class="div amount_item">{{ $t('The withdrawal is being processed') }}: <span style="color:#EC3031;">{{ freeze_predeposit }}</span></span>
      </div>

      <div class="div predeposit_handle">
        <div class="ph-flex">
          <div class="div item" @click="$router.push({ name: 'MemberRechargeList' })">
            <span class="ds-button">{{ $t('Recharge') }}</span>
          </div>
          <div class="div item" @click="$router.push({ name: 'MemberWithdrawList' })">
            <span class="ds-button">{{ $t('Withdraw') }}</span>
          </div>
        </div>
        <div class="address">
          <div class="box addicon" v-if="btnShow" @click="goAdd">
            <div class="v">{{ $t('Add Recipient Account First') }}</div>
            <div class="add">
              <img src="../../../assets/image/home/addAddress.png" />
            </div>
          </div>
          <div class="box" v-else>
            <span class="t" v-if="bank_list[0].address_type == 'opBNB'">USDT Address (opBNB): </span>
            <span class="t" v-else>USDT-BNB Smart Chain (BEP20):</span>
            <span class="v">{{ bank_list[0].memberbank_no }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="div account mt-5">
      <div class="div menu"></div>
    </div>
    <div class="fundet">
      <div class="tit">{{ $t('Fund Details') }}</div>
      <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
        <div class="list-wrapper" v-if="predeposit_list && predeposit_list.length">
          <div class="item" v-for="(item, index) in predeposit_list" :key="item.lg_id">
            <label class="subtitle">{{ item.lg_desc }}</label>
            <label class="title">{{ item.lg_addtime_text }}</label>
            <label class="date" v-bind:class="item.lg_av_amount > 0 ? 'income' : 'expend'">
              {{ item.lg_av_amount > 0 ? '+' : '' }}{{ item.lg_av_amount }}$
            </label>
          </div>
        </div>
        <empty-record v-else-if="predeposit_list && !predeposit_list.length"></empty-record>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import { getMemberIndex } from '../../../api/member'
import { getPredepositList } from '../../../api/memberPredeposit'
import { getBankList } from '../../../api/memberBank'
import { mapState } from 'vuex'
import flexLine from '../../flexLine'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    flexLine,
    EmptyRecord
  },
  data() {
    return {
      available_predeposit: 0.00,
      freeze_predeposit: 0.00,
      voucher_count: 0,
      points: 0,
      available_rc_balance: 0,
      params: { 'page': 0, 'per_page': 20 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      predeposit_list: false,
      btnShow: true,
      bank_list: null,

      scrollY: 0,
      startChangeAt: 20, // 开始改变背景色的滚动阈值
      maxOpacity: 1, // 最大不透明度
      opacityMultiplier: 20, // 滚动距离到最大不透明度的倍数
    }
  },
  created() {
    this.getBankList()

    getMemberIndex().then(
      response => {
        if (response && response.result.member_info) {
          this.available_predeposit = response.result.member_info.available_predeposit
          this.freeze_predeposit = response.result.member_info.freeze_predeposit
          this.voucher_count = response.result.member_info.voucher_count
          this.points = response.result.member_info.member_points
          this.available_rc_balance = response.result.member_info.available_rc_balance
        }
      },
      error => { }
    )
  },
  computed: {
    headerStyle() {
      let newOpacity = Math.min(this.maxOpacity, (this.scrollY - this.startChangeAt) / this.opacityMultiplier);
      if (this.scrollY > this.startChangeAt) {
        return { backgroundColor: `rgba(255, 255, 255, ${newOpacity})` };
      } else {
        return { backgroundColor: 'transparent' };
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
    },
    goAdd() {
      this.$router.push({ name: 'MemberBankForm', query: { action: 'add' } })
    },
    getBankList() {
      getBankList().then(res => {
        this.bank_list = res.result.bank_list
        if (this.bank_list.length > 0) {
          this.btnShow = false
        } else {
          this.btnShow = true
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    loadMore() {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getPredepositList(true)
      }
    },
    getPredepositList() {
      Indicator.open()
      getPredepositList(this.params).then(res => {
        Indicator.close()
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }

        let temp = res.result.list
        if (temp) {
          if (!this.predeposit_list) {
            this.predeposit_list = temp
          } else {
            this.predeposit_list = this.predeposit_list.concat(temp)
          }
        }
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.ph-flex{
  display: flex;
  justify-content: space-between;
}
.container {
  background-size: 100% 20rem;
  background-repeat: no-repeat;
  background-color: #fff;
}

.common-header-wrap .common-header {
  box-shadow: unset;
  background: transparent;
  transition: background-color 0.3s ease;
}

.account_header {
  display: flex;
  justify-content: space-between;
  background: url('../../../assets/image/member/wallet_bg.png');
  margin: 1rem auto;
  width: 1082px;
  height: 222px;
  background-repeat: no-repeat;
  background-size: cover;
  color: #333333;
  padding: .7rem;
  font-size: $fontSize;
  box-sizing: border-box;
  border-radius: 5px;

  .predeposit {
    width: 50%;
    text-align: center;
    padding: .5rem 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .predeposit_title {
      font-size: 18px;
      color: #333333;
      margin-bottom: .5rem;
    }

    .available_predeposit {
      padding-bottom: 20px;
      font-size: 1.5rem;
      color: #EC3031;
    }
  }

  .amount-wrapper {
    overflow: hidden;

    .amount_item {
      font-size: 16px;
      text-align: center;
    }

    .amount_item:nth-child(2) {
      text-align: right;
    }
  }
}

.card-wrapper {
  background-color: #fff;
  display: flex;
  padding: .5rem 0;
  justify-content: center;
  align-items: center;

  .card_item {
    width: 36%;
    margin: 0 6%;
    background-color: #F5A623;
    padding: .8rem 0;
    border-radius: .5rem;
    text-align: center;

    .img {
      width: 1.5rem;
      height: 1.5rem;
    }

    .explain {
      font-size: $subFontSize;
      color: #fff;
    }
  }

  .card_item:nth-child(3) {
    background-color: #FF862F;
  }

  .border {
    width: 1px;
    background-color: #cdcdcd;
    height: 2.8rem;
  }
}

.predeposit_handle {
  padding-top: 40px;
  width: 50%;
  text-align: center;
  align-items: stretch;
  background-color: transparent;

  .item {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    .img {
      width: 3rem;
    }

    span {
      width: 4rem;
      text-align: center;
      background: linear-gradient(90deg, #E8090C 0%, #F3611E 100%);
      border-radius: 10px;
      padding: .4rem;
      font-size: .7rem;
      color: #ffffff;
      margin-top: 10px;
    }
  }
}

.account {
  padding: 0 $pageSpace;
  background: #fff;

  .menu {
    background: #fff;
  }
}

.address {
  padding: .9rem .7rem;
  margin: 1rem .8rem 0;
  border-radius: 3px 3px 0 0;

  .addicon {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .add {
      width: 2rem;
      height: 1.2rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .t {
    font-size: 13px;
    margin-bottom: .2rem;
  }

  .v {
    font-size: 15px;
  }
}

.fundet {
  padding: 1.5rem 1rem;
  background: #FFFFFF;
  border-radius: 25px 25px 0 0;

  .tit {
    display: inline-block;
    background: #E7010C;
    border-radius: 10px 10px 10px 10px;
    color: #fff;
    padding: .5rem 1rem;
    font-size: 14px;
  }
}

.list-wrapper {
  margin-top: 1rem;
  border-radius: 20px 20px 20px 20px;
  border: 1px solid #e8eaed;
  padding: 1rem;

  .item {
    display: flex;
    position: relative;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #fff;
    border-bottom: 1px solid #e8eaed;

    &:last-child {
      border-bottom: none;
    }

    .title {
      font-size: 14px;
      color: #999999;
      margin-left: 0.7rem;
      margin-bottom: 0.7rem;
    }

    .income {
      color: $primaryColor;
    }

    .expend {
      color: #333;
    }
  }

  .title {
    font-size: $h1;
    margin-left: 0.7rem;
    margin-bottom: 0.7rem;
  }

  .income {
    color: $primaryColor;
  }

  .expend {
    color: #333;
  }

  .subtitle {
    font-size: 18px;
    color: #333333;
    margin-left: 0.7rem;
    margin-top: 0.4rem;
    margin-bottom: 0.5rem;
  }

  .date {
    color: #EC3031;
    font-size: 22px;
    position: absolute;
    top: 0.9rem;
    right: 0.7rem;
  }
}
</style>
